import dataEnvelopeService from '../../services/DataService';
import CoreBase from '../../services/engines/CoreBase';
import responseHelper from '../../services/ResponseHelper';
import config from '../../config.json';
import umlNotesEngine from './UmlNotesEngine';
import umlSchemaFormData from './UmlSchemaFormData';
import journalService from '../../services/JournalService';

/**
 *  save uml canvas data into journal note
 */
class UmlCanvasSaver extends CoreBase {
    /**
     * Saves Uml canvas data to note
     *
     * @param {*} noteRk the journal note rk can be empty when new
     * @param {*} body the note body aka the json data of canvas
     * @param {*} meta no idea why this exists everything is inside note ...
     * @returns
     */
    saveSchema = async (noteRk, body, meta = {}) => {
        try {
            const note = {
                rk: noteRk,
                uid: this.getUid(),
                title: meta.name ?? '',
                service: meta.service ?? 'Jerny.UmlWorkspace',

                type: 'UmlSchema',
                format: meta.format ?? 'class-diagram',
                remark: meta.remarks ?? '',
                stateId: 0,

                body: JSON.stringify(body),
            };

            const dto = { data: note };
            const resp = await journalService.createOrUpdate(dto);
            if (responseHelper.check(resp, '', 'UmlSchemaFetcher.saveSchema') < 0) {
                this.logError('saveSchema', `code: ${resp?.status}`);
                return null;
            }

            // Direct in cache zetten — Load Uml-lijst klopt meteen, hoeft niet te wachten
            // op de SignalR OnJournalCreated/OnJournalUpdated round-trip.
            umlNotesEngine.upsert(note);

            return resp.data;
        } catch (error) {
            this.logError('saveSchema', error.message);
            return null;
        }
    };
}

const umlCanvasSaver = new UmlCanvasSaver();
export default umlCanvasSaver;
